import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { EncryptionService } from 'src/app/modules/dashboard/services/encryption.service';
import { QESApproveRejectComponent } from 'src/app/modules/pr-buyer/components/qes-approve-reject/qes-approve-reject.component';
import { IAPIResponse } from 'src/app/modules/shared/models';

@Injectable({
  providedIn: 'root'
})
export class qesService {

  private stdCol: any[] = [
    { headerName: 'Categories', field: 'categories', editable: false },
    { headerName: 'Siemens Requirement', field: 'siemens_requirement', editable: false }
  ]

  private _vendorSub = new BehaviorSubject<Array<any>>([...this.stdCol]);
  private _listOfQuotedVendors = new BehaviorSubject<Array<any>>([]);
  private _qesNoSub = new BehaviorSubject<any | null>(null);

  constructor(private http: HttpClient,private _modalService: BsModalService, private _encryptionService : EncryptionService) { }

  private selectedVendorsForQES: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  private _qesBasicVendorDetails: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  private _qesVendorAdditionalCostDetails: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  private _qesVendorExcludeCostDetails: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  private _multiselect: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public  QesStatusDetails = '';
  public  BU_SCMP = '';
  public setqesNoSub(newValue: any | null): void {
    this._qesNoSub.next(newValue);
  }

  public getQesBasicVendorSub<T>(): Observable<Array<any>> {
    return this._qesBasicVendorDetails.asObservable()
  }

  public getQesBasicVendorSubValue(): Array<any> {
    return this._qesBasicVendorDetails.getValue();
  }

  public setQesBasicVendorSub(newValue: Array<any>): void {
    this._qesBasicVendorDetails.next(newValue);
  }
  public getVendorAdditionalCostSub<T>(): Observable<Array<any>> {
    return this._qesVendorAdditionalCostDetails.asObservable()
  }

  public getVendorAdditionalCostSubValue(): Array<any> {
    return this._qesVendorAdditionalCostDetails.getValue()
  }

  public setVendorAdditionalCostSub(newValue: Array<any>): void {
    this._qesVendorAdditionalCostDetails.next(newValue);
  }

  public getVendorExcludeCostSub(): Array<any> {
    return this._qesVendorExcludeCostDetails.getValue()
  }

  public setVendorExcludeCostSub(newValue: Array<any>): void {
    this._qesVendorExcludeCostDetails.next(newValue);
  }

  public getqesNoSub<T>(): Observable<any | null> {
    return this._qesNoSub.asObservable()
  }

  public getqesNoValue(): any | null {
    return this._qesNoSub.getValue()
  }

  public setsSelectedVendorsForQES(newValue: any[]): void {
    this.selectedVendorsForQES.next(Object.assign([], newValue));
  }

  public getVendorsForQES(_qesNoSub: string | undefined) {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_BASIC_VENDOR_DETAILS}?qesNo=${_qesNoSub}`);
  }

  public isQesButtonDisabled(qesStatus: string, qesBasicDetailsForm: any): boolean {
    if (qesStatus === 'QES_SUBMITTED') {
      return true;
    } else {
      return false;
    }
  }

  public selectedVendorsForQESSubscription<T>(): Observable<Array<any>> {
    return this.selectedVendorsForQES.asObservable()
  }

  public saveQESBasicInfo(qes_basic_info: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.SAVE_BASIC_INFORMATION}`, qes_basic_info);
  }

  public fetchQESBasicInfo(prId: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_BASIC_INFORMATION}prId=${prId}`);
  }

  public addVendor(columnDef: any[]): void {
    this._vendorSub.next(columnDef);
  }

  public vendorSubscription<T>(): Observable<Array<T>> {
    return this._vendorSub.asObservable();
  }

  public listOfQuotedVendors(vendors: any[]): void {
    this._listOfQuotedVendors.next(vendors);
  }

  public getListOfQuotedVendors() {
    return this._listOfQuotedVendors.getValue();
  }

  public addMultiselect(vendors: any[]): void {
    this._multiselect.next(vendors);
  }

  public getMultiselectSubscription<T>(): Observable<Array<T>> {
    return this._multiselect.asObservable();
  }

  public getMultiSelectSubValue() {
    return this._multiselect.getValue();
  }

  public qesVendorBasicDetails(list_of_vendors: any[], qesVendorDetails: any[], columnDefs?: any[]): Array<any> {
    const rowDataCategories = ["Vendor code", "Supplier Name", "Vendor City", "EHS Category", "Vendors contact person", "Vendors contact number", "Original Currency", "Conversion Factor"
      , "Goods Origin Factor / Port of landing (*)", "Technical Specification compiled (*)", "Quotation reference (*)", "Delivery", "Penalty", "Liquidated damage (LD)", "Warranty", "Bank Gaurantee(Advance, Contract, Performance)",
      "Vendor terms of payment", "Initial terms of payment", "Final terms of payment", "Advance %", "Advance", "Original quoted price (INR) - Material/Supply",
      "Original quoted price (INR) - Services", "Other Cost(+ / -)", "Original quoted price (INR) - Total", "Reduction achieved with reference to quoted price %", "Reduction achieved with reference to quoted price (INR)", "Discounted/Negotiated price(INR) - Material/Supply",
      "Discounted/Negotiated price(INR) - Services", "Discounted/Negotiated price(INR) - Total"];
    const keys = ["id", "vendor_code", "supplier_name", "vendor_city", "EHS_category", "vendor_contact_person", "vendor_contact_number", "original_currency", "conversion_factor", "goodsOriginFactor_or_portOfLanding", "technical_specification_compiled", "quotation_reference", "delivery",
      "penalty", "liquidated_damages", "warranty", "bank_guarantee_AdvanceContractPerformance", "vendor_payment_terms", "initial_payment_terms", "final_payment_terms", "advance_percentage", "advance", "original_quoted_price_material_supply",
      "original_quoted_price_services", "original_quoted_price_total", "other_cost", "reductions_referencing_quoted_price_percent", "reductions_referencing_quoted_price", "negotiated_price_material_supply", "negotiated_price_services",
      "negotiated_price_total", "vendor_id", "is_siemens_requirement", "qes_basic_details_id"];
    const rowCategoriesMap = new Map([
      ["Vendor code", "vendor_code"], ["Vendor ID", "supplier_id"], ["Supplier Name", "vendor_name"], ["Vendor City", "vendor_city"], ["EHS Category", "EHS_category"], ["Vendors contact person", "vendor_contact_person"],
      ["Vendors contact number", "vendor_contact_number"], ["Original Currency", "original_currency"], ["Conversion Factor", "conversion_factor"], ["Goods Origin Factor / Port of landing (*)", "goodsOriginFactor_or_portOfLanding"],
      ["Technical Specification compiled (*)", "technical_specification_compiled"], ["Quotation reference (*)", "quotation_reference"], ["Delivery", "delivery"], ["Penalty", "penalty"], ["Advance", "advance"],
      ["Liquidated damage (LD)", "liquidated_damages"], ["Warranty", "warranty"], ["Bank Gaurantee(Advance, Contract, Performance)", "bank_guarantee_AdvanceContractPerformance"], ["Original quoted price (INR) - Material/Supply", "original_quoted_price_material_supply"],
      ["Vendor terms of payment", "vendor_payment_terms"], ["Initial terms of payment", "initial_payment_terms"], ["Final terms of payment", "final_payment_terms"], ["Advance %", "advance_percentage"],
      ["Original quoted price (INR) - Services", "original_quoted_price_services"], ["Other Cost(+ / -)", "other_cost"], ["Original quoted price (INR) - Total", "original_quoted_price_total"], ["Discounted/Negotiated price(INR) - Material/Supply", "negotiated_price_material_supply"],
      ["Discounted/Negotiated price(INR) - Services", "negotiated_price_services"], ["Discounted/Negotiated price(INR) - Total", "negotiated_price_total"], ["Reduction achieved with reference to quoted price %", "reductions_referencing_quoted_price_percent"], ["Reduction achieved with reference to quoted price (INR)", "reductions_referencing_quoted_price"]
    ]);
    let empty_row = [];
    let is_siemens_record: any[] = [];
    if(qesVendorDetails.length) {
      is_siemens_record = qesVendorDetails.filter(row => row.is_siemens_requirement == true);
    }
    let row_data: any = [];
    if (columnDefs?.length) {
      const keys = columnDefs.map(item => item.field);
      empty_row = rowDataCategories.map((key, idx) => {
        const obj: any = {};
        keys.forEach(row => {
          if (row === 'categories') {
            obj[row] = key;
          } else {
            obj[row] = null;
          }
        });
        return obj;
      });
    }
    if (list_of_vendors?.length && qesVendorDetails?.length) {
      list_of_vendors.forEach((vendor: any) => {
        const is_not_siemens_record = qesVendorDetails.filter(row => row.is_siemens_requirement == false);
        const record = is_not_siemens_record.length ? qesVendorDetails.filter(row => row.vendor_code == vendor.vendor_code) : [];
        if (record.length) {
          row_data.push(record[0]);
        } else {
          const row: any = {};
          keys.map((value: any) => {
            row[`${value}`] = vendor[`${value}`];

          });
          row_data.push(row);
        }
      });
      if(is_siemens_record.length) {
        row_data.push(is_siemens_record[0]);
      }
      if (row_data.length) {
        const objKeys = Object.keys(row_data[0]).filter(key => key !== 'id' && key !== 'vendor_id' && key !== 'qes_basic_details_id' && key !== 'is_siemens_requirement');
        let siemens_req: any[] = [];
        if (row_data.length) {
          siemens_req = row_data.filter((item: any) => item.is_siemens_requirement == true);
          qesVendorDetails = row_data.filter((item: any) => item.is_siemens_requirement !== true);
        }
        const rowData = objKeys.map((key, idx) => {
          const v: any = {};
          qesVendorDetails.map((obj: any) => {
            v['categories'] = rowDataCategories[idx];
            v['siemens_requirement'] = siemens_req.length ? siemens_req[0][rowCategoriesMap.get(rowDataCategories[idx])!] : null;
            v[`${obj.vendor_code}-vendor`] = obj[rowCategoriesMap.get(rowDataCategories[idx])!];
          });
          return v;
        });
        return rowData;
      }
    }
    return empty_row;
  }

  public transformQesDataToVendorDetails(list_of_vendors: any[], renderedData: any[], isSiemensRequirement: boolean) {
    let returnData: any[] = [];
    const rowCategoriesMap = new Map([
      ["New Vendor", "new_vendor"], ["Vendor ID", "supplier_id"], ["Supplier Name", "vendor_name"], ["Vendor City", "vendor_city"], ["EHS Category", "EHS_category"], ["Vendors contact person", "vendor_contact_person"],
      ["Vendors contact number", "vendor_contact_number"], ["Original Currency", "original_currency"], ["Conversion Factor", "conversion_factor"], ["Goods Origin Factor / Port of landing (*)", "goodsOriginFactor_or_portOfLanding"],
      ["Technical Specification compiled (*)", "technical_specification_compiled"], ["Quotation reference (*)", "quotation_reference"], ["Delivery", "delivery"], ["Penalty", "penalty"], ["Advance", "advance"],
      ["Liquidated damage (LD)", "liquidated_damages"], ["Warranty", "warranty"], ["Bank Gaurantee(Advance, Contract, Performance)", "bank_guarantee_AdvanceContractPerformance"], ["Original quoted price (INR) - Material/Supply", "original_quoted_price_material_supply"],
      ["Vendor terms of payment", "vendor_payment_terms"], ["Initial terms of payment", "initial_payment_terms"], ["Final terms of payment", "final_payment_terms"], ["Advance %", "advance_percentage"],
      ["Original quoted price (INR) - Services", "original_quoted_price_services"], ["Other Cost(+ / -)", "other_cost"], ["Original quoted price (INR) - Total", "original_quoted_price_total"], ["Discounted/Negotiated price(INR) - Material/Supply", "negotiated_price_material_supply"],
      ["Discounted/Negotiated price(INR) - Services", "negotiated_price_services"], ["Discounted/Negotiated price(INR) - Total", "negotiated_price_total"], ["Reduction achieved with reference to quoted price %", "reductions_referencing_quoted_price_percent"], ["Reduction achieved with reference to quoted price (INR)", "reductions_referencing_quoted_price"]
    ]);

    const objKeys = isSiemensRequirement ? Object.keys(renderedData[0]).filter(key => key !== 'categories' && key !== 'vendor_code') : Object.keys(renderedData[0]).filter(key => key !== 'categories' && key !== 'siemens_requirement' && key !== 'vendor_code');
    for (const item of objKeys) {
      const vendor = list_of_vendors.length ? list_of_vendors.filter((ven: any) => ven.vendor_code == item.split('-')[0]) : [];
      const newObj: { [key: string]: any } = item === 'siemens_requirement' ?
        {
          "is_siemens_requirement": true,
          "supplier_id": vendor[0]?.id,
          "vendor_code": vendor[0]?.vendor_code
        } :
        {
          "is_siemens_requirement": false,
          "supplier_id": vendor[0]?.id,
          "vendor_code": vendor[0]?.vendor_code
        };
      for (let row of renderedData) {
        if (rowCategoriesMap.has(row.categories)) {
          newObj[rowCategoriesMap.get(row.categories)!] = row[item];
        }
      }
      returnData.push(newObj);
    }
    return returnData;
  }

  public saveQESBasicVendorDetails(qes_vendor_basic_info: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.SAVE_BASIC_VENDOR_DETAILS}`, qes_vendor_basic_info);
  }

  public saveQESAdditionalCostDetails(qes_additional_cost: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.SAVE_ADDITIONAL_COST_DETAILS}`, qes_additional_cost);
  }

  public downloadQESPdf(qesId: any): Observable<any> {
    console.log(qesId,"qesId")
    return this.http.post<any>(API_URL.QESPdf, {qesId:qesId},{responseType: 'application/pdf' as any}); //testPDF
  }

  public getQESAdditionalCostDetails(_qesNo: string | undefined) {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_QES_ADDITIONAL_COST}qesNo=${_qesNo}`);
  }

  public transformRowdataToAdditionalCost(list_of_vendors: any[], renderedData: any[], isSiemensRequirement: boolean) {
    let returnData: any[] = [];
    const rowCategoriesMap = new Map([
      ["Vendor ID", "qes_vendor_id"], ["International freight (INR)", "international_freight"], ["Customs Duty (INR)", "customs_duty"], ["CVD + SAD (INR)", "CVD_SAD"], ["Customs clearance charge (INR)", "customs_clearance_charge"], ["Packing (INR)", "packing"],
       ["Goods and service tax (GST) %", "goods_and_services_tax_percent"],
      ["Goods and service tax (GST) Amount", "goods_and_services_tax_amount"], ["Any other levy (+ / -)", "any_other_levy"], ["Domestic Freight (INR)", "domestic_freight"], ["Transit Insurance (INR) %", "transit_insurance_percent"], ["Transit Insurance Amount", "transit_insurance_amount"],
      ["Total price (INR)", "total_price"], ["Loading due to difference in commercial terms", "loading_due_to_diff_in_commercial_terms"], ["Loading due to PT difference", "loading_due_to_PT_difference"], ["Other Cost (+/-)", "other_cost"], ["Total price post loading (INR)", "total_price_post_loading"]
    ]);

    const objKeys = isSiemensRequirement ? Object.keys(renderedData[0]).filter(key => key !== 'categories') : Object.keys(renderedData[0]).filter(key => key !== 'categories' && key !== 'siemens_requirement');
    for (const item of objKeys) {
      const newObj: { [key: string]: any } = item === 'siemens_requirement' ?
        { "is_siemens_requirement": true, "qes_vendor_id": null } :
        { "is_siemens_requirement": false, "qes_vendor_id": item.split('-')[0] };
      for (let row of renderedData) {
        if (rowCategoriesMap.has(row.categories)) {
          newObj[rowCategoriesMap.get(row.categories)!] = row[item];
        }
      }
      returnData.push(newObj);
    }
    return returnData;
  }

  public transformRowdataToExcludecost(list_of_vendors: any[], renderedData: any[], isSiemensRequirement: boolean) {
    let returnData: any[] = [];
    const rowCategoriesMap = new Map([
      ["Vendor ID", "qes_vendor_id"], ["International freight (INR)", "international_freight_enabled"], ["Customs Duty (INR)", "customs_duty_enabled"], ["CVD + SAD (INR)", "CVD_SAD_enabled"], ["Customs clearance charge (INR)", "customs_clearance_charge_enabled"], ["Packing (INR)", "packing_enabled"], ["Reduction achieved with reference to consider cost", "reduction_achieved_referring_CTC"],
      ["Evaluated total price (cost of company)", "evaluated_total_price_costToCompany"], ["Price firm/ variable", "price_firm_or_variable"],
      ["Goods and service tax (GST) Amount", "goods_and_services_tax_amount_enabled"], ["Any other levy (+ / -)", "any_other_levy_enabled"], ["Domestic Freight (INR)", "domestic_freight_enabled"], ["Transit Insurance (INR) %", "transit_insurance_percent"], ["Transit Insurance Amount", "transit_insurance_amount"], ["Saving price", "saving_price"],
      ["Total Additional Cost (INR)", "total_price"], ["Loading due to difference in commercial terms", "loading_due_to_diff_in_commercial_terms_enabled"], ["Loading due to PT difference", "loading_due_to_diff_in_commercial_terms_enabled"], ["Other Cost (+/-)", "other_cost_enabled"], ["Total price post loading (INR)", "total_price_post_loading"], ["Saving due to SCM action", "saving_due_to_SCM"],
      ["Saving due to Engg.action", "saving_due_to_engg"], ["Saving due to proccess action/ other function", "saving_due_to_process_or_other_action"], ["Remarks", "remarks"], ["Supplier approved by siemens customer", "supplier_approved_by_siemens_customer"], ["Clients preference", "client_preference"]
    ]);
    
    const objKeys = isSiemensRequirement ? Object.keys(renderedData[0]).filter(key => key !== 'categories') : Object.keys(renderedData[0]).filter(key => key !== 'categories' && key !== 'siemens_requirement');
    for (const item of objKeys) {
      const vendor = list_of_vendors.length ? list_of_vendors.filter((line: any) => line.vendor_code == item.split('-')[0]) : [];
      const newObj: { [key: string]: any } = item === 'siemens_requirement' ?
        { "is_siemens_requirement": true, "qes_vendor_id": null } :
        { "is_siemens_requirement": false, "qes_vendor_id": item.split('-')[0] };
      for (let row of renderedData) {
        if (rowCategoriesMap.has(row.categories)) {
          newObj[rowCategoriesMap.get(row.categories)!] = row[item];
        }
      }
      returnData.push(newObj);
    }
    return returnData;
  }

  public transformQESDataToRowdata(_qesData: any[], rowDataCategories: any[], columnDefs?: any[]): Array<any> {
    let empty_row: any = [];
    const keys = ['international_freight', 'customs_duty', 'cvd_sad', 'customs_clearance_charge', 'packing',
      'goods_and_services_tax_percent','goods_and_services_tax_amount', 'any_other_levy', 'domestic_freight', 'transit_insurance_percent','transit_insurance_amount','other_cost', 'total_price', 'loading_due_to_diff_in_commercial_terms', 'total_price_post_loading', 'loading_due_to_PT_difference' , 
      ];
      console.log("rowDataCategories",rowDataCategories)
    if (columnDefs?.length) {
      const keys = columnDefs.map(item => item.field);
      empty_row = rowDataCategories.map((key, idx) => {
        console.log("key",key,idx)
        const obj: any = {};
        keys.forEach(row => {
          if (row === 'categories') {
            obj[row] = key;
          } else {
            obj[row] = null;
          }
        });
        console.log("obj",obj)
        return obj;
      });
    }
    if (_qesData.length) {
      const objKeys = Object.keys(_qesData[0]).filter(key => keys.includes(key));
      let siemens_req: any[] = [];
      if (_qesData.length) {
        siemens_req = _qesData.filter(item => item.is_siemens_requirement !== false);
        _qesData = _qesData.filter(item => item.is_siemens_requirement !== true);
      }
      const rowData = keys.map((key, idx) => {
        console.log("Keyy",key)
        const v: any = {};
        _qesData.map((obj: any) => {
          v['categories'] = rowDataCategories[idx];
          v['siemens_requirement'] = siemens_req.length ? siemens_req[0][`${key}`] : null;
          v[`${obj.qes_vendor_id}-vendor`] = obj[`${key}`];
        });
        console.log("v",v)
        return v;
      });
      return rowData;
    }
    return empty_row;
  }

  public transformQESExcludeDataToRowdata(_qesData: any[], rowDataCategories: any[], columnDefs?: any[]): Array<any> {
    let empty_row = [];
    const keys = ['international_freight_enabled', 'customs_duty_enabled', 'cvd_sad_enabled', 'customs_clearance_charge_enabled', 'packing_enabled', 'goods_and_services_tax_amount_enabled', 'any_other_levy_enabled', 'domestic_freight_enabled', 'transit_insurance_amount', 'total_price', 'loading_due_to_diff_in_commercial_terms_enabled', 'loading_due_to_PT_difference_enabled', 'other_cost_enabled',
      'evaluated_total_price_costToCompany', 'reduction_achieved_referring_CTC', 'price_firm_or_variable', 'saving_price'];
      // ['saving_due_to_SCM', 'saving_due_to_engg', 'saving_due_to_process_or_other_action', 'remarks', 'supplier_approved_by_siemens_customer', 'client_preference'];
      console.log("rowDataCategories", rowDataCategories);
      console.log("columnDefs",columnDefs)
    if (columnDefs?.length) {
      const keys = columnDefs.map(item => item.field);
      empty_row = rowDataCategories.map((key, idx) => {
        const obj: any = {};
        keys.forEach(row => {
          console.log("row",row)
          if (row === 'categories') {
            obj[row] = key;
          } else {
            obj[row] = null;
          }
        });
        return obj;
      });
    }
    if (_qesData.length) {
      const objKeys = Object.keys(_qesData[0]).filter(key => keys.includes(key));
      console.log("objKeys",objKeys)
      let siemens_req: any[] = [];
      if (_qesData.length) {
        siemens_req = _qesData.filter(item => item.is_siemens_requirement !== false);
        _qesData = _qesData.filter(item => item.is_siemens_requirement !== true);
      }
      const rowData = objKeys.map((key, idx) => {
        console.log("key",key, idx)
        const v: any = {};
        _qesData.map((obj: any) => {
          v['categories'] = rowDataCategories[idx];
          v['siemens_requirement'] = siemens_req.length ? siemens_req[0][`${key}`] : null;
          v[`${obj.qes_vendor_id}-vendor`] = obj[`${key}`] ? obj[`${key}`] : null;
        });
        console.log("v",v)
        return v;
      });
      return rowData;
    }
    return empty_row;
  }

  public fetchQESSinglesourceJustification(_qesNo: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_SINGLE_SOURCE_JUSTIFICATION}qesNo=${_qesNo}`);
  }

  public postQESSinglesourceJustification(singleSourceJustification: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.SAVE_SINGLE_SOURCE_JUSTIFICATION}`, singleSourceJustification);
  }

  public fetchQESAdditionalEvaluation(_qesNo: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_ADDITIONAL_EVALUATION}qesNo=${_qesNo}`);
  }

  public transformQESAdditionalEvaluationToRowdata(_qesData: any[], rowDataCategories: any[], columnDefs?: any[]): Array<any> {
    let empty_row: any[] = [];
    const keys = ['supplier_comparison_factor', 'evaluated_cost_considering_SCF_factor', 'SCF_as_per_EHS', 'evaluation_total_price_after_SCF', 'vendor_price_level', 'vendor_recommended', 'sourcing_review_required', 'split_order_value', 'qes_to_be_updated_or_cancelled_percent',
      'qes_to_be_updated_or_cancelled_value', 'remarks', 'po_number', 'is_agreed_with_commodity_manager', 'split_order_value', 'sourcing_review_document'];
    if (columnDefs?.length) {
      const keys = columnDefs.map(item => item.field);
      empty_row = rowDataCategories.map((key, idx) => {
        const obj: any = {};
        keys.forEach(row => {
          if (row === 'categories') {
            obj[row] = key;
          } else {
            obj[row] = null;
          }
        });
        return obj;
      });
    }
    if (_qesData.length) {
      const objKeys = Object.keys(_qesData[0]).filter(key => keys.includes(key));
      let siemens_req: any[] = [];
      if (_qesData.length) {
        siemens_req = _qesData.filter(item => item.is_siemens_requirement !== false);
        _qesData = _qesData.filter(item => item.is_siemens_requirement !== true);
      }
      const rowData = objKeys.map((key, idx) => {
        const v: any = {};
        _qesData.map((obj: any) => {
          v['categories'] = rowDataCategories[idx];
          v['siemens_requirement'] = siemens_req.length ? siemens_req[0][`${key}`] : null;
          v[`${obj.id}-vendor`] = obj[key];
        });
        return v;
      });
      return rowData;
    }
    return empty_row;
  }

  public transformRowdataToAdditionalEvaluation(renderedData: any[], isSiemensRequirement: boolean) {
    let returnData: any[] = [];
    const rowCategoriesMap = new Map([["Supplier comparison factor", "supplier_comparison_factor"], ["Evaluated cost considering SCF factor", "evaluated_cost_considering_SCF_factor"], ["SCF as per EHS evaluation score (EHS)", "SCF_as_per_EHS"],
    ["Evaluation total price after SCF", "evaluation_total_price_after_SCF"], ["Vendor price level", "vendor_price_level"], ["Vendor recommended", "vendor_recommended"], ["Sourcing review required", "sourcing_review_required"],
    ["QES to be updated / cancelled", "qes_to_be_updated_or_cancelled_value"], ["Remarks", "remarks"], ["P.O. Number", "po_number"], ["Discussedand agreed with commodity Manager", "is_agreed_with_commodity_manager"],
    ["Split order value", "split_order_value"], ["Sourcing review document", "sourcing_review_document"]
    ]);

    const objKeys = isSiemensRequirement ? Object.keys(renderedData[0]).filter(key => key !== 'categories') : Object.keys(renderedData[0]).filter(key => key !== 'categories' && key !== 'siemens_requirement');
    for (const item of objKeys) {
      const newObj: { [key: string]: any } = item === 'siemens_requirement' ? { "is_siemens_requirement": true, qes_vendor_id: item.split('-')[0] } : { "is_siemens_requirement": false, qes_vendor_id: item.split('-')[0] };
      for (let row of renderedData) {
        if (rowCategoriesMap.has(row.categories)) {
          newObj[rowCategoriesMap.get(row.categories)!] = row[item];
        }
      }
      returnData.push(newObj);
    }
    return returnData;
  }

  public saveQESAdditionalEvaluationDetails(qesEvaluationDetails: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.SAVE_ADDITIONAL_EVALUATION_DETAILS}`, qesEvaluationDetails);
  }

  public fetchQESAttachments(_qesNo: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_QES_ATTACHMENTS}qesNo=${_qesNo}`);
  }

  public fetchRFQAttachments(_qesNo: any, prId: any): Observable<any> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_RFQ_ATTACHMENTS}prId=${this._encryptionService.encryptPayload(encodeURIComponent(prId))}&qesId=${this._encryptionService.encryptPayload(encodeURIComponent(_qesNo))}`);
  }

  public uploadQesAttachmnet(qes_no: any, remarks: string, uploadedFile: FormData): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.ATTACHMENTS.UPLOAD_ATTACHMENT}qesId=${this._encryptionService.encryptPayload(qes_no)}&remarks=${this._encryptionService.encryptPayload(remarks)}`, uploadedFile);
  }

  public deleteQesAttachmnet(file_id: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.ATTACHMENTS.DELETE_ATTACHMNET}id=${this._encryptionService.encryptPayload(file_id)}`, null);
  }

  public downloadQesAttachmnet(qes_no: any): any {
    return this.http.get<any>(`${API_URL.BUYER.QES.ATTACHMENTS.DOWNLOAD_ATTACHMENT}${qes_no}`, {
      responseType: 'blob' as any,
    });
  }

  public downloadRFQQesAttachmnet(id:any): any {
    return this.http.get<any>(`${API_URL.BUYER.RFQ.DOWNLOAD_ATTACHMENT}?id=${id}`, {
      responseType: 'blob' as any,
    });
  }

  public fetchListOfQuotedSAPVendors(prId: any): Observable<IAPIResponse<any>> {
    // return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_QUOTED_VENDORS}${prId}`);
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_QUOTED_VENDORS_LIST}?prId=${prId}`);
  }

  public fetchListOfApprovers(qesNo: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.APPROVERS.FETCH_LIST_OF_APPROVERS}qesId=${qesNo}`);
  }

  public fetchQesMasterData(payload:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.APPROVERS.FETCH_QES_MASTER_DATA}`, payload);
  }

  public fetchApproverDetails(qesNo: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.APPROVERS.FETCH_APPROVER_DETAILS}qesId=${qesNo}`);
  }

  public submitQES(qes_no: any, selectedApprovers: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.SUBMIT_QES}id=${this._encryptionService.encryptPayload(qes_no)}`, selectedApprovers);
  }

  public fetchQesDetailsByApproverId(): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.QES_APPROVER.GET_ALL_PR}`);
  }

  public updateQesDetailsByApproverId(body: any, qesNo: string): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.QES_APPROVER.UPDATE_QES}qesNo=${this._encryptionService.encryptPayload(qesNo)}`, body);
  }

  public getQesAutopoulatevalues(domain: string, prId: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.FETCH_QES_PREPOLUATE_DATA}prId=${this._encryptionService.encryptPayload(encodeURIComponent(prId))}&domain=${this._encryptionService.encryptPayload(encodeURIComponent(domain))}`);
  }

  public getPurchaseRequestDetail(prId : string | null | undefined): Observable<IAPIResponse<Array<any>>> {
    const id = prId? parseInt(prId): prId;
    return this.http.post<IAPIResponse<Array<any>>>(`${API_URL.GET_ALL_PR}`, { prId : [id]});
  }

  public qesEhsVendorDetailSaveOrUpdate(payload:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.QES_EHS_VENDORDETAILS}`, payload)
  }
  
  public updateQESStatus(rawApprovalList: any) {
    const initialState: ModalOptions<any> = {
      initialState: {
        rawApprovalList: rawApprovalList
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this._modalService.show(QESApproveRejectComponent, initialState);
    return 
  }

  public getQESEHSVendorDetails(payload: any):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.GET_QES_EHS_VENDOR_DETAILS}`,payload)
  }

  public qesValidation(payload: any):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.QESVALIDATION_API}`, payload)
  }

  public getVendorCountForQes(payload: any):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.GET_VENDOR_COUNT_FOR_SINGLE_SOURCE_JUDTIFICATION}`, payload)
  }

  public getPOnumbersForQES(qesId: any):Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.QES.MAP_PO_NUMBER_IN_QES}?qesId=`+qesId)
  }

  public addPOnumbersForQES(payload: any):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.MAP_PO_NUMBER_IN_QES}`,payload)
  }

  public deletePOnumbersForQES(id: any):Observable<IAPIResponse<any>>{
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.QES.MAP_PO_NUMBER_IN_QES}?id=${this._encryptionService.encryptPayload(id)}`,{})
  }

}
